import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=3e05736e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e05736e"]])

export default __exports__